<template>
  <main class="main full-screen flex-column align-center">
    <button class="to-miniprogram-button" @click="toMiniProgram()">
      选月嫂
    </button>
  </main>
</template>

<script lang="ts">
import { PostConfig, post } from "@/assets/utils/common";
import { api } from "@/assets/utils/config";
import { Toast } from "vant";
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      schemeUrl: "",
    };
  },

  mounted() {
    this.getUrlScheme();
  },

  methods: {
    getUrlScheme() {
      let config: PostConfig = {
        url: api.getUrlScheme,
        param: { path: "pages/index/index" },
      };
      return post(config).then((res: any) => {
        if (res.status == 0) {
          this.schemeUrl = res.data;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    toMiniProgram() {
      if (!this.schemeUrl) {
        Toast.loading("请稍等...");
        this.getUrlScheme().then(() => {
          location.href = this.schemeUrl;
        });
        return;
      }
      location.href = this.schemeUrl;
    },
  },
});
</script>

<style lang="less" scoped>
.main {
  overflow: hidden;
  position: relative;
  background: #f2f1ef url("https://mm2015.mamalaile.com.cn/1982d890456cf7fd1a1ddf0681412915.png") no-repeat 0 0;
  background-size: 100%;

  .to-miniprogram-button {
    width: 58.67vw;
    @hr: 11.73vw;
    height: @hr;
    line-height: @hr;
    border-radius: @hr;
    text-align: center;
    font-size: 4.8vw;
    color: white;
    font-family: @font-ab;
    background-color: @color-primary;
    position: absolute;
    top: 160vw;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
